import { render, staticRenderFns } from "./InvestMaturityBenefit.vue?vue&type=template&id=38ec8df0&scoped=true"
import script from "./InvestMaturityBenefit.vue?vue&type=script&lang=js"
export * from "./InvestMaturityBenefit.vue?vue&type=script&lang=js"
import style0 from "./InvestMaturityBenefit.vue?vue&type=style&index=0&id=38ec8df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec8df0",
  null
  
)

export default component.exports